function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6665 16.1654C13.8433 16.1654 14.0129 16.0951 14.1379 15.9701C14.2629 15.8451 14.3332 15.6755 14.3332 15.4987V4.81403C14.3328 3.75782 13.913 2.74498 13.166 1.99825C12.419 1.25152 11.4061 0.832031 10.3498 0.832031H2.33317C2.15636 0.832031 1.98679 0.902269 1.86177 1.02729C1.73674 1.15232 1.6665 1.32189 1.6665 1.4987V15.4987C1.6665 15.6755 1.73674 15.8451 1.86177 15.9701C1.98679 16.0951 2.15636 16.1654 2.33317 16.1654H13.6665Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 0.886719V3.50072C11 3.67753 11.0702 3.8471 11.1953 3.97212C11.3203 4.09715 11.4899 4.16739 11.6667 4.16739H14.28",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.65283 10.5C5.65283 10.7652 5.54748 11.0196 5.35994 11.2071C5.1724 11.3946 4.91805 11.5 4.65283 11.5H3.65283V9.5H4.65283C4.91805 9.5 5.1724 9.60536 5.35994 9.79289C5.54748 9.98043 5.65283 10.2348 5.65283 10.5Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.65283 13.5V11.5",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.98584 9.5C7.51627 9.5 8.02498 9.71071 8.40005 10.0858C8.77513 10.4609 8.98584 10.9696 8.98584 11.5C8.98584 12.0304 8.77513 12.5391 8.40005 12.9142C8.02498 13.2893 7.51627 13.5 6.98584 13.5V9.5Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3193 13.5V10.1667C10.3193 9.98986 10.3896 9.82029 10.5146 9.69526C10.6396 9.57024 10.8092 9.5 10.986 9.5H12.3193",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3193 11.5H11.6527",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgFilePdf = function SvgFilePdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilePdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file_pdf.0a622d92.svg";
export { ForwardRef as ReactComponent };